export const FETCH_GROUPS_REQUEST = 'FETCH_GROUPS_REQUEST';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS';
export const FETCH_GROUPS_FAILURE = 'FETCH_GROUPS_FAILURE';

export const FETCH_GROUP_REQUEST = 'FETCH_GROUP_REQUEST';
export const FETCH_GROUP_SUCCESS = 'FETCH_GROUP_SUCCESS';
export const FETCH_GROUP_FAILURE = 'FETCH_GROUP_FAILURE';

export const UPDATE_GROUPS_REQUEST = 'UPDATE_GROUPS_REQUEST';
export const UPDATE_GROUPS_SUCCESS = 'UPDATE_GROUPS_SUCCESS';
export const UPDATE_GROUPS_FAILURE = 'UPDATE_GROUPS_FAILURE';

export const DELETE_GROUPS_REQUEST = 'DELETE_GROUPS_REQUEST';
export const DELETE_GROUPS_SUCCESS = 'DELETE_GROUPS_SUCCESS';
export const DELETE_GROUPS_FAILURE = 'DELETE_GROUPS_FAILURE';

export const OPEN_EDIT_GROUP_PAGE = 'OPEN_EDIT_GROUP_PAGE';
export const OPEN_EDIT_GROUP_PAGE_SUCCESS = 'OPEN_EDIT_GROUP_PAGE_SUCCESS';

export const KPI_GROUPS_REQUEST = 'KPI_GROUPS_REQUEST';
export const KPI_GROUPS_SUCCESS = 'KPI_GROUPS_SUCCESS';
export const KPI_GROUPS_FAILURE = 'KPI_GROUPS_FAILURE';

export const CLEAR_GROUP_ERRORS = 'CLEAR_GROUP_ERRORS';
export const CLEAR_GROUP_SUCCESS = 'CLEAR_GROUP_SUCCESS';